/* eslint eqeqeq: 0 */
import { combineReducers } from "redux";
import {
  SET_CID,
  ON_LOAD_CAMPAIGN_DROP_DOWN
} from "../constants/campaignDropDown";
import { ON_CREATE_CAMPAIGN_SUCCESS } from "../constants/campaignList";

function campaigns(state = [], action) {
  if (action.type == ON_LOAD_CAMPAIGN_DROP_DOWN) {
    return action.payload;
  }
  if (action.type == ON_CREATE_CAMPAIGN_SUCCESS) {
    return [action.campaign].concat(state);
  }
  return state;
}

function cid(state = null, action) {
  if (action.type == SET_CID) {
    return action.cid;
  }
  if (action.type == ON_CREATE_CAMPAIGN_SUCCESS) {
    return action.campaign.id;
  }
  return state;
}

export default combineReducers({
  campaigns,
  cid
});
